import { gql } from '@apollo/client';

export const REQUEST_WITH_PENDING_QUOTES = gql`
  query customerEventRequest($filter: CustomerEventRequestFilter!) {
    customerEventRequest(filter: $filter) {
      uuid
      quotes(where: { state: { equals: pending } }) {
        uuid
        supplier: suppliers {
          uuid
          images
          name
          category_tier1
          tagline
          average_rating
        }
      }
    }
  }
`;
